import { ICategory } from '../category/category.types';
import { WeekDay } from '../menu/enums.types';
import { IItem } from '../menu/item.types';
import { IMenu } from '../menu/menu.types';
import { OrderSource } from '../ticket/ticket.types';

export enum DealStatus {
  ACTIVE = 'ACTIVE',
  COMPLETE = 'COMPLETE',
  DRAFT = 'DRAFT',
  SCHEDULED = 'SCHEDULED',
}

export enum DealTerms {
  ONE_PER_TABLE = 'Only one discount can be redeemed per table',
  USE_WITH_OTHERS = 'Allow to be used with other deals or discounts',
  AUTOMATIC_APPLY = 'Automatically applied at checkout when conditions are met',
}

export enum DealType {
  DISCOUNT = '$ or %OFF',
  BTGT = 'Buy this, get that',
  GIFT_WITH_PURCHASE = 'Free gift with purchase',
  GIFT_WITHOUT_PURCHASE = 'Free gift without purchase',
}

export enum AmountType {
  PERCENTAGE = '%',
  PRICE = '$',
}

export enum AppliedType {
  ANY = 'Any item',
  LEAST_EXPENSIVE = 'Least expensive item',
  MOST_EXPENSIVE = 'Most expensive item',
}

export enum ItemsType {
  MENU = 'Menu',
  CATEOGRY = 'Category',
  ITEM = 'Item',
}

export enum HourType {
  ALL_DAY = 'allDay',
  SELECT_HOURS = 'selectHours',
}

export interface Terms {
  description: string;
  isChecked: boolean;
  isAuto?: boolean;
}

export interface DiscountDeal {
  amount: number;
  type: AmountType;
  isMinimumSpend?: boolean;
  isEntire?: boolean;
  isAll?: boolean;
  minimumSpend?: number;
  getType?: ItemsType;
  buyType?: ItemsType;
}

export interface BTGTDeal {
  amount: number;
  type: AmountType;
  minimumBuy: number;
  maximumGet: number;
  appliedOn: AppliedType;
  buyType: ItemsType;
  getType: ItemsType;
}

export interface GiftDeal {
  minimumBuy?: number;
  maximumGet: number;
  buyType?: ItemsType;
  // Will always be ITEM
  getType: ItemsType;
}

export interface DealItem {
  id: number;
  itemBuy?: IItem;
  itemGet?: IItem;
}
export interface DealMenu {
  id: number;
  menuBuy?: IMenu;
  menuGet?: IMenu;
}
export interface DealCategory {
  id: number;
  categoryBuy?: ICategory;
  categoryGet?: ICategory;
}

export interface IDealDataResponse {
  id: number;
  name: string;
  type: DealType;
  status: DealStatus;
  description: string;
  images: string[];
  startDate: Date;
  endDate: Date;
  startTime: Date;
  endTime: Date;
  promoCode: string;
  promoUsage: number;
  isPromo: boolean;
  isArchived: boolean;
  days: WeekDay[];
  orderSources: OrderSource[];
  customTerms: Terms[];
  definedTerms: DealTerms[];
  details: DiscountDeal | BTGTDeal | GiftDeal;
  items: DealItem[];
  menus: DealMenu[];
  categories: DealCategory[];
  buyItems?: {
    value: number;
    label: string;
    times?: { startTime: string; endTime: string }[];
  }[];
  getItems?: {
    value: number;
    label: string;
    times?: { startTime: string; endTime: string }[];
  }[];
  dealTicketStats?: {
    useCount: number;
    sales: number;
  };
}

export interface IDealCreateRequestType {
  restaurantId: number;
  step: number;
  status?: DealStatus;
  type: DealType;
  details: DiscountDeal | BTGTDeal | GiftDeal;
  buyItems: number[];
  getItems: number[];
  startDate: Date;
  endDate?: Date;
  startTime: Date;
  endTime?: Date;
  days: WeekDay[];
  orderSources: OrderSource[];
  name: string;
  description: string;
  isPromo?: boolean;
  promoCode?: string;
  promoUsage?: number;
  customTerms?: Terms[];
  definedTerms?: DealTerms[];
}

export interface IDealEventBridge {
  id: number;
  key: string;
  name: string;
  restaurantId: number;
  businessId: number;
  time: string;
  date: string;
  timezone: string;
  action: DealStatus;
}

export interface IDealUpdateRequestType {
  isArchived?: boolean;
  status?: DealStatus.COMPLETE | DealStatus.DRAFT;
}

export interface IDealResponseType {
  response: {
    success: boolean;
    data: { deals: IDealDataResponse[] };
    message: string;
  };
  statusCode: number;
}

export interface IDealRequestResponseType {
  response: {
    success: boolean;
    data: { deal: IDealDataResponse | null; campaignName: string };
    message: string;
  };
  statusCode: number;
}

export interface IDealUpdateRequestResponseType {
  response: {
    success: boolean;
    data: { deal: IDealDataResponse | null };
    message: string;
  };
  statusCode: number;
}

export interface Days {
  id: number;
  name: string;
  value: string;
  checked: boolean;
}

export interface BuyItems {
  value: number;
  label: string;
  times?: { startTime: string; endTime: string }[];
}

export type GetItems = BuyItems;
